import React, { Component } from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { useParams } from 'react-router-dom';


const titleSx = {
  fontSize: '30px',
  color: 'white',
  maxWidth: '750px',
  margin: '65px auto 65px auto',
  textAlign: 'center',
  '@media (max-width: 600px)': { fontSize: '22px' },
  '@media (max-width: 450px)': { fontSize: '18px' },
};

const metaSx = {
    fontSize: '14px',
    color: 'lightgray',
    textAlign: 'left',
    margin: '0 auto 65px auto', // ⬅️ more space between title and paragraph
    maxWidth: '650px',
    '@media (max-width: 600px)': {
      fontSize: '12px',
      padding: '0 12px',
    },
  };

const paragraphSx = {
  fontSize: '15.5px',
  color: 'white',
  lineHeight: 2.2,
  textAlign: 'left',
  maxWidth: '650px',
  margin: '20px auto',
  opacity: 0.92,
  '@media (max-width: 600px)': {
    fontSize: '14px',
    lineHeight: 2,
    padding: '0 12px',
  },
  '@media (max-width: 450px)': {
    fontSize: '13px',
    lineHeight: 1.9,
  },
};

class BlogPostPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      blog: null,
      screenWidth: window.innerWidth,
      fadeIn: false,
    };
  }

  async componentDidMount() {
    const slug = this.props.params.slug;
    try {
      const response = await fetch(`/blogs/${slug}.json`);
      const blog = await response.json();
      this.setState({ blog }, () => {
        setTimeout(() => this.setState({ fadeIn: true }), 30);
      });
      this.setState({ blog });
    } catch (err) {
      console.error('Error loading blog:', err);
    }

    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    this.setState({ screenWidth: window.innerWidth });
  };

  render() {
    const { blog } = this.state;
    if (!blog) return <div style={{ color: 'white', paddingTop: '160px', textAlign: 'center' }}>Loading blog...</div>;

    return (
        <Box
            sx={{
                paddingTop: '160px',
                paddingBottom: '80px',
                backgroundColor: 'rgba(0, 0, 0, 0.45)',
                borderRadius: '20px',
                maxWidth: '880px',
                margin: 'auto',
                paddingX: '20px',
                boxShadow: '0 0 50px rgba(0,0,0,0.3)',
                opacity: this.state.fadeIn ? 1 : 0,
                transition: 'opacity 1s ease-in',
            }}
            >
        <Box
          component="img"
          src={blog.image}
          alt={blog.title}
          sx={{
            width: '90%',
            maxWidth: '650px',
            borderRadius: '20px',
            margin: '0 auto 20px auto',
            display: 'block',
            boxShadow: '0 0 30px rgba(255,255,255,0.2)',
            opacity: "0.75"
          }}
        />
        <Typography sx={titleSx}>{blog.title}</Typography>
        <Typography sx={metaSx}>By {blog.publishedBy} on {blog.publishedAt}</Typography>
        {blog.paragraphs.map((p, idx) => {
            if (typeof p === 'string' && p.startsWith('{image:') && p.endsWith('}')) {
                const img = p.slice(7, -1);
                return (
                <Box key={idx} sx={{ textAlign: 'center', margin: '40px 0' }}>
                    <img src={img} alt="" style={{ maxWidth: '100%', opacity: "0.7", borderRadius: '14px', boxShadow: '0 0 20px rgba(255,255,255,0.1)' }} />
                </Box>
                );
            }
            return <Typography key={idx} sx={paragraphSx}>{p}</Typography>;
            })}
      </Box>
    );
  }
}

function withRouter(Component) {
    return function Wrapper(props) {
      const params = useParams();
      return <Component {...props} params={params} />;
    };
  }

export default withRouter(BlogPostPage);